export enum OrderStep {
  Confirm = 'confirm',
  Processing = 'processing',
  Complete = 'complete',
  OverTrial = 'overTrial',
  Error = 'error',
  View = 'view', // specific to viewing chain of title report
  VendorError = 'vendorError',
}

export enum DocType {
  PrelimTitleReport = 'prelimTitleReport',
  ChainOfTitleReport = 'chainOfTitleReport',
  MapReport = 'mapReport',
  OpenLienReport = 'openLienReport',
  TransactionHistoryReport = 'transactionHistoryReport',
}

export type DocTypeMap = { [Doc in DocType]: string };

/** A report order that produced no reports, with the reason sent to PostHog. */
export class ReportOrderError extends Error {
  constructor(readonly reason: string) {
    super('Unable to generate reports');
  }
}

export const docTypeMap: DocTypeMap = {
  prelimTitleReport: 'Prelim Title Report',
  chainOfTitleReport: 'Chain of Title Report',
  mapReport: 'Map Report',
  openLienReport: 'Open Lien Report',
  transactionHistoryReport: 'Transaction History Report',
};
